import { useCallback, useEffect, useRef, useState } from 'react';

const useTyping = (text: string | string[], animationDelay: number) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const lastTimestamp = useRef<number | null>(null);

  useEffect(() => {
    let animationFrameId: number;
    const animateTyping = (timestamp: number) => {
      if (lastTimestamp.current === null) lastTimestamp.current = timestamp;
      const elapsed = timestamp - lastTimestamp.current;
      if (elapsed > animationDelay) {
        lastTimestamp.current = timestamp;

        if (currentIndex < text.length) {
          setDisplayedText((state) => {
            const newState = (state += text[currentIndex]);
            setCurrentIndex((prevIndex) => prevIndex + 1);
            return newState;
          });
        }
      }
      animationFrameId = requestAnimationFrame(animateTyping);
    };
    animationFrameId = requestAnimationFrame(animateTyping);

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [currentIndex, animationDelay, text]);

  const reset = useCallback(() => {
    setDisplayedText('');
    setCurrentIndex(0);
    lastTimestamp.current = null;
  }, []);

  return {
    displayedText,
    reset,
  };
};

export default useTyping;
